import { MantineProvider } from '@mantine/core'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import UnleashProvider from '@unleash/proxy-client-react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router'
import { configureCognito } from '../configs/cognito'
import { unleashClient } from './clients/unleash-client'
import { CognitoAuthProvider } from './contexts/cognitoAuthContext'
import { AntdLocaleProvider } from './locales/AntdLocaleProvider'
import i18n from './locales/i18n'
import { PersistQueryClientProvider } from './queries/QueryClientProvider'
import { AppRoutes } from './routes'
import { theme } from './styles/mantine'

configureCognito()

export function App() {
  return (
    <UnleashProvider unleashClient={unleashClient} startClient>
      <I18nextProvider i18n={i18n}>
        <MantineProvider theme={theme}>
          <AntdLocaleProvider language={i18n.language}>
            <PersistQueryClientProvider>
              <BrowserRouter>
                <NuqsAdapter>
                  <CognitoAuthProvider>
                    <AppRoutes />
                  </CognitoAuthProvider>
                </NuqsAdapter>
              </BrowserRouter>
            </PersistQueryClientProvider>
          </AntdLocaleProvider>
        </MantineProvider>
      </I18nextProvider>
    </UnleashProvider>
  )
}
